__turbopack_context__.v({
  "eyebrow": "Footer-module__8-teKW__eyebrow",
  "footer": "Footer-module__8-teKW__footer",
  "inner": "Footer-module__8-teKW__inner",
  "link": "Footer-module__8-teKW__link",
  "linkdivider": "Footer-module__8-teKW__linkdivider",
  "links": "Footer-module__8-teKW__links",
});
